import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class VisitorsMonthlyLimitReached extends Component {
  @service abilities;
  @service basicVisitorsGating;
  @service router;

  get canVisitBilling() {
    return this.abilities.can('visit billing');
  }

  get nextResetLabel() {
    return this.basicVisitorsGating.nextResetLabel;
  }

  @action
  goToPlans() {
    this.router.transitionTo('billing.product-plans', 'visitors');
  }
}
